import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import stripePaymentService from '../../../services/stripePaymentService';

const StripeInvoicesTable = ({ invoices, onPayInvoice, onViewInvoice, onPayViaBankPortal }) => {
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString)?.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  const getTierDisplay = (tierName) => {
    const tierMap = {
      'tier_1_10': '1-10 Employees',
      'tier_10_50': '10-50 Employees',
      'tier_50_500': '50-500 Employees',
      'tier_500_plus': '500+ Employees'
    };
    return tierMap?.[tierName] || tierName;
  };

  if (!invoices || invoices?.length === 0) {
    return (
      <div className="text-center py-12">
        <Icon name="FileText" size={48} className="mx-auto text-muted-foreground mb-4" />
        <p className="text-muted-foreground">No invoices available</p>
      </div>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead>
          <tr className="border-b border-border">
            <th className="text-left py-3 px-4 text-sm font-semibold text-foreground">Invoice #</th>
            <th className="text-left py-3 px-4 text-sm font-semibold text-foreground">Billing Period</th>
            <th className="text-left py-3 px-4 text-sm font-semibold text-foreground">Tier</th>
            <th className="text-left py-3 px-4 text-sm font-semibold text-foreground">Employees</th>
            <th className="text-left py-3 px-4 text-sm font-semibold text-foreground">Amount</th>
            <th className="text-left py-3 px-4 text-sm font-semibold text-foreground">Status</th>
            <th className="text-left py-3 px-4 text-sm font-semibold text-foreground">Due Date</th>
            <th className="text-right py-3 px-4 text-sm font-semibold text-foreground">Actions</th>
          </tr>
        </thead>
        <tbody>
          {invoices?.map((invoice) => (
            <tr key={invoice?.id} className="border-b border-border hover:bg-muted/50 transition-colors">
              <td className="py-3 px-4 text-sm text-foreground font-medium">
                {invoice?.invoiceNumber || `#${invoice?.id?.slice(0, 8)?.toUpperCase()}`}
              </td>
              <td className="py-3 px-4 text-sm text-foreground">
                {formatDate(invoice?.billingPeriodStart)} - {formatDate(invoice?.billingPeriodEnd)}
              </td>
              <td className="py-3 px-4 text-sm text-foreground">
                {getTierDisplay(invoice?.tierAtBilling)}
              </td>
              <td className="py-3 px-4 text-sm text-foreground">
                {invoice?.employeeCountAtBilling}
              </td>
              <td className="py-3 px-4 text-sm font-semibold text-foreground">
                K{parseFloat(invoice?.amountDue)?.toFixed(2)}
              </td>
              <td className="py-3 px-4">
                <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${
                  stripePaymentService?.getStatusColor(invoice?.status)
                }`}>
                  {invoice?.status?.toUpperCase()}
                </span>
              </td>
              <td className="py-3 px-4 text-sm text-muted-foreground">
                {formatDate(invoice?.dueDate)}
              </td>
              <td className="py-3 px-4 text-right">
                <div className="flex items-center justify-end space-x-2">
                  {invoice?.status === 'open' && (
                    <div className="flex items-center space-x-2">
                      <Button
                        size="sm"
                        onClick={() => onPayInvoice?.(invoice)}
                      >
                        <Icon name="CreditCard" size={14} className="mr-1" />
                        Pay with Card
                      </Button>
                      <Button
                        size="sm"
                        variant="outline"
                        onClick={() => onPayViaBankPortal?.(invoice)}
                      >
                        <Icon name="Building2" size={14} className="mr-1" />
                        Bank Portal
                      </Button>
                    </div>
                  )}
                  {invoice?.invoicePdfUrl && (
                    <button
                      onClick={() => window.open(invoice?.invoicePdfUrl, '_blank')}
                      className="inline-flex items-center text-primary hover:text-primary/80 transition-colors"
                      title="Download PDF"
                    >
                      <Icon name="Download" size={16} />
                    </button>
                  )}
                  {invoice?.hostedInvoiceUrl && (
                    <button
                      onClick={() => window.open(invoice?.hostedInvoiceUrl, '_blank')}
                      className="inline-flex items-center text-primary hover:text-primary/80 transition-colors"
                      title="View Invoice"
                    >
                      <Icon name="ExternalLink" size={16} />
                    </button>
                  )}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default StripeInvoicesTable;